export default "__VITE_ASSET__kbXwbLAD__"